module.exports = __webpack_public_path__ + "img/header-memoireRingsWhite.d76dde2.webp";